var _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "bounds"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bounds)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h60v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 8,
    d: "m0 0 60 40M60 0 0 40"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c8102e",
    strokeWidth: 3,
    d: "m0 0 60 40M60 0 0 40"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 13,
    d: "M30 0v40M0 20h60"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c8102e",
    strokeWidth: 8,
    d: "M30 0v40M0 20h60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/gb.2fd50528b6b5c0f7316b98e7598716db.svg";
export { ForwardRef as ReactComponent };